// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__121S0","overlay":"Popup_overlay__EJtEj","container":"Popup_container__quzYe","close":"Popup_close__FhUCu"};